/**
 * Bewertungen der Website.
 *
 * Hier stehen ausschließlich echte Google-Bewertungen. Solange die Liste leer
 * ist, zeigt der Abschnitt "Bewertungen" einen ehrlichen Hinweis statt
 * erfundener Stimmen, und die Kennzahl "Ø Kundenbewertung" im Abschnitt
 * "Warum wir" wird ausgeblendet - eine Durchschnittsnote ohne Bewertungen
 * wäre eine Behauptung ins Blaue.
 *
 * Ab dem ersten Eintrag erscheint beides von selbst. Am Aussehen der Seite
 * muss dafür nichts geändert werden.
 */

// Link zum eigenen Google-Unternehmensprofil. Sobald hier eine Adresse steht,
// erscheint im Abschnitt "Bewertungen" ein Verweis dorthin.
export const googleProfilUrl = "";

/**
 * Echte Google-Bewertungen. Pro Bewertung ein Eintrag nach diesem Muster:
 *
 *   {
 *     quote: "Wortlaut der Bewertung, unverändert übernommen.",
 *     author: "Vorname Nachname",
 *     role: "Unternehmen oder Ort",
 *     stars: 5,
 *   },
 *
 * Wichtig: Bewertungen im Wortlaut übernehmen und keine Kritik herauskürzen.
 * Erfundene oder geschönte Bewertungen sind in Deutschland abmahnbar
 * (§ 5 UWG, Anhang Nr. 23b zu § 3 Abs. 3 UWG).
 */
export const googleBewertungen = [];

export const anzahlBewertungen = googleBewertungen.length;
export const hatEchteBewertungen = anzahlBewertungen > 0;

/** Durchschnitt der Sterne, auf eine Nachkommastelle gerundet. */
export const bewertungenSchnitt = hatEchteBewertungen
  ? Math.round(
      (googleBewertungen.reduce((summe, b) => summe + (b.stars ?? 5), 0) / anzahlBewertungen) * 10,
    ) / 10
  : 0;
